var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrows = function SvgArrows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.587413 5.80402C0.416084 5.80402 0.269231 5.8794 0.171329 5.9799C0.048951 6.10553 0 6.25628 0 6.40704C0 6.58291 0.048951 6.73367 0.171329 6.83417L3.08392 9.82412C3.18182 9.94975 3.32867 10 3.5 10C3.64685 10 3.79371 9.94975 3.91608 9.82412L6.82867 6.83417C6.92657 6.73367 7 6.58291 7 6.40704C7 6.25628 6.92657 6.10553 6.82867 5.9799C6.70629 5.8794 6.55944 5.80402 6.41259 5.80402H0.587413ZM6.82867 3.16583C6.92657 3.29146 7 3.44221 7 3.59296C7 3.76884 6.92657 3.9196 6.82867 4.0201C6.70629 4.14573 6.55944 4.19598 6.41259 4.19598H0.587413C0.416084 4.19598 0.269231 4.14573 0.171329 4.0201C0.048951 3.9196 0 3.76884 0 3.59296C0 3.44221 0.048951 3.29146 0.171329 3.16583L3.08392 0.175879C3.18182 0.0753769 3.32867 0 3.5 0C3.64685 0 3.79371 0.0753769 3.91608 0.175879L6.82867 3.16583Z",
    fill: "#303A5F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrows.ed4ccc5d.svg";
export { ForwardRef as ReactComponent };